import { useState } from 'react';
import axios from 'axios';
import { API_ENDPOINTS, PLATFORM_KEY_OPTIONS } from '../config/launchConfig';

const useGameFlexAuth = (updateServerState) => {
    const [operatorOptions, setOperatorOptions] = useState([]);
    const [brandOptions, setBrandOptions] = useState([]);

    const authenticateUser = async (platformKey, username, password) => {
        console.log('Authenticating user...', { platformKey, username });
        if (!username || !password) {
            alert('Enter Username & Password');
            return false;
        }

        try {
            const response = await axios.post(API_ENDPOINTS.AUTHENTICATE, {
                platformKey,
                username,
                password,
            });

            if (response.data.token) {
                updateServerState((prev) => ({ ...prev, token: response.data.token }));
                await fetchOperators(platformKey, response.data.token);
                return true;
            } else {
                alert('Authentication failed.');
                return false;
            }
        } catch (error) {
            console.error('Authentication failed', error);
            alert('Authentication failed. Check credentials.');
            return false;
        }
    };

    const fetchOperators = async (platformKey, token) => {
        console.log('Fetching operators...', { platformKey, token });
        try {
            const response = await axios.post(
                API_ENDPOINTS.OPERATORS,
                { platformKey, authToken: token },
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                }
            );

            let parsedData = typeof response.data === "string" ? JSON.parse(response.data) : response.data;

            if (parsedData?.result?.length > 0) {
                const operators = parsedData.result.map((op) => ({
                    label: `${op.OperatorCode} - ${op.Name}`,
                    value: op.OperatorCode
                }));
                console.log('Setting operator options:', operators);
                setOperatorOptions(operators);
            }
        } catch (error) {
            console.error('Failed to fetch operators', error);
            setOperatorOptions([]);
        }
    };

    const handlePlatformChange = async (event, newValue, username, password) => {
        console.log('Platform change initiated:', { newValue, username });
        if (!newValue) return;

        const selectedPlatform = PLATFORM_KEY_OPTIONS.find((p) => p.key === newValue);
        if (!selectedPlatform) return;

        // First update the state
        updateServerState((prev) => ({
            ...prev,
            platformKey: newValue,
            rootUrl: selectedPlatform.url,
            token: '',
            operatorCode: null,
            brand: null,
        }));

        // Then authenticate
        const success = await authenticateUser(newValue, username, password);

        // If authentication failed, reset the platform selection
        if (!success) {
            updateServerState((prev) => ({
                ...prev,
                platformKey: null,
                rootUrl: '',
                token: '',
            }));
        }
    };

    const handleOperatorChange = async (event, newValue, currentPlatformKey) => {
        if (!newValue || !currentPlatformKey) return;

        const operatorCode = newValue.value;
        updateServerState((prev) => ({
            ...prev,
            operatorCode,
            brand: null
        }));

        try {
            console.log('Fetching brands with:', { platformKey: currentPlatformKey, operatorCode });
            const response = await axios.post(
                API_ENDPOINTS.BRANDS,
                {
                    platformKey: currentPlatformKey,
                    operatorCode
                },
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                }
            );

            let parsedData = typeof response.data === "string" ? JSON.parse(response.data) : response.data;
            if (typeof parsedData === "string") parsedData = JSON.parse(parsedData);

            if (parsedData.status === "Success" && Array.isArray(parsedData.result)) {
                const brands = parsedData.result.map((brand) => brand.BrandID + ' - ' + brand.Name);
                setBrandOptions(brands);
            }
        } catch (error) {
            console.error("Failed to fetch brands", error);
            setBrandOptions([]);
        }
    };

    return {
        operatorOptions,
        brandOptions,
        handlePlatformChange,
        handleOperatorChange,
        setBrandOptions
    };
};

export default useGameFlexAuth;